var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSupportFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C15.5356 4 18.4578 6.63776 18.9325 10.0634C19.55 10.2488 20 10.8219 20 11.5V14.5C20 15.1655 19.5666 15.7298 18.9667 15.926C18.6376 18.0602 15.8614 20 12 20C11.7239 20 11.5 19.7761 11.5 19.5C11.5 19.2239 11.7239 19 12 19C15.2561 19 17.5154 17.5189 17.9309 16.0002L17.5 16C17.2239 16 17 15.7761 17 15.5V10.5C17 10.2239 17.2239 10 17.5 10L17.9107 10.0004C17.4193 7.15912 14.9594 5 12 5C9.04064 5 6.58068 7.15912 6.08931 10.0004L6.5 10C6.77614 10 7 10.2239 7 10.5V15.5C7 15.7761 6.77614 16 6.5 16H5.5C4.67157 16 4 15.3284 4 14.5V11.5C4 10.8219 4.45001 10.2488 5.0677 10.0632C5.54215 6.63776 8.46444 4 12 4ZM12 8C14.6888 8 16.8818 10.1223 16.9954 12.7831L17 13L16.9954 13.2169C16.8818 15.8777 14.6888 18 12 18C9.23858 18 7 15.7614 7 13C7 10.2386 9.23858 8 12 8ZM13.1824 15H10.8177C10.7027 15 10.5912 15.0396 10.5021 15.1122C10.2879 15.2865 10.2555 15.6015 10.4299 15.8156C10.8012 16.2719 11.3245 16.5 12 16.5C12.6755 16.5 13.1989 16.2719 13.5702 15.8156C13.6427 15.7264 13.6824 15.615 13.6824 15.5C13.6824 15.2239 13.4585 15 13.1824 15Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportFilled);
export default __webpack_public_path__ + "static/media/supportFilled.b9efa088bdf79ddef92dfbe0359a0a67.svg";
export { ForwardRef as ReactComponent };